import HttpReference from '../platform/HttpReference';

export default class VehicleYears extends HttpReference {
  get() {
    // TODO
  }
}
